import { AvailableLDUsersToAdd } from 'types/store/learningTeam';
import { User, UserAvatars } from 'utils/customTypes';
import { isUserStatusDisabled } from 'utils/functions';

export const serializeUsersForDropdown = (users: User[]): UserAvatars[] => {
  return users.map((user) => ({
    label: `${user.data?.firstName} ${user.data?.lastName}`,
    value: user.id,
    disabled: isUserStatusDisabled(user.status),
    avatar: {
      imageSrc: user.avatar_url,
      initial: `${user.data?.firstName?.charAt(0)}${user.data?.lastName?.charAt(
        0
      )}`,
      name: `${user.data?.firstName} ${user.data?.lastName}`,
    },
  }));
};

export const serializeAvailableLDUsersToAddForDropdown = (
  users: AvailableLDUsersToAdd[]
): UserAvatars[] => {
  return users.map((user) => ({
    label: `${user.data?.firstName} ${user.data?.lastName}`,
    value: user.id,
    disabled: user.isTeamManager ?? false,
    avatar: {
      imageSrc: user.avatar_url,
      initial: `${user.data?.firstName?.charAt(0)}${user.data?.lastName?.charAt(
        0
      )}`,
      name: `${user.data?.firstName} ${user.data?.lastName}`,
    },
  }));
};
